module.exports = __webpack_public_path__ + "static/media/tour-compl-3.e57ee3c5.png";